import React, { Component } from 'react';

class AccountValidateConfirmation extends Component {
  render() {
    return (
      <div className="p-5 form-container" id="view-validate-local-account-confirmation">
        <div className="text-center">
          <h1 className="h4 text-gray-900 mb-4">Ο λογαριασμός σου ενεργοποιήθηκε!</h1>
        </div>
        <p className="mb-4">Σε ευχαριστούμε που ενεργοποίησες το λογαριασμό σου.</p>
        <p className="mb-4">Τώρα μπορείς να μπεις στο σύστημα και να διαχειριστείς τις
          μελλοντικές συνεδρίες σου καθώς επίσης και να συνδεθείς σε τρέχουσες διασκέψεις.</p>
      </div>
    );
  }
}

export default AccountValidateConfirmation;